/**
 * Pragmapower Constants
 * Contains pragmapower types, assessment types, and related enums
 */

export enum PRAGMAPOWER_TYPE {
  Technical = 1,
  Team = 2,
}

export const PRAGMAPOWER_TYPES = {
  TECHNICAL: 'Technical',
  TEAM: 'Team',
  TEAM_TECHNICAL: 'TeamTechnical',
} as const;

export const PRAGMAPOWER_TYPE_IDS = {
  TECHNICAL: 1,
  TEAM: 2,
} as const;

export enum assessmentType {
  TECHNICAL = 'Technical',
  TEAM = 'Team',
  TECHNICAL_TYPE_ID = 0,
  TEAM_TYPE_ID = 1,
}

export enum assessmenType {
  Technical = 'Technical',
}

export enum BUTTON_TYPES {
  TeamPragmapower = 'Team PragmaPower',
  TechnicalPragmapower = 'Technical PragmaPower',
  Valoration = 'Valoración',
}
